import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class InterceptorService implements HttpInterceptor {
  requestInProgressSubject = new Subject;
  requestInProgress = 0;

  disconnected = false;

  constructor(
    private router: Router,
  ) {
    this.requestInProgressSubject.subscribe((value: number) => {
      this.requestInProgress = value;
      if (value === 0) {
        if (this.disconnected) {
          this.disconnected = false;
          localStorage.clear();
          this.router.navigate(['/auth/login']).then(() => {});
        }
      }
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requestInProgressSubject.next(this.requestInProgress + 1);
    if (request.url.indexOf('api-adresse.data.gouv.fr') === -1) {
      request = request.clone({ withCredentials: true });
    }

    return next.handle(request).pipe(
      mergeMap((event: HttpEvent<any>) => {
        return new Observable<any>((observer) => {
          if (event instanceof HttpResponse) {
            if (!event.body['success']) {
              if (event.body['errors'] &&
                event.body['errors']['general'] &&
                event.body['errors']['general']['code'] === 'NOT_CONNECTED') {
                this.disconnected = true;
                observer.next(event);
              } else {
                observer.next(event);
              }
            } else {
              observer.next(event);
            }
            this.requestInProgressSubject.next(this.requestInProgress - 1);
          } else if (event instanceof HttpErrorResponse) {
            this.requestInProgressSubject.next(this.requestInProgress - 1);
            const response = new HttpResponse({body: {success: false}});
            observer.next(response);
          }
        });
      })
    );
  }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/services/interceptor.service.ts